/**
 * Canonical hex values for MapLibre paint expressions.
 *
 * MapLibre paint properties are evaluated by the GPU shader pipeline and cannot
 * read CSS custom properties, so we keep the hex literals here rather than in
 * globals.css. These values must stay in sync with the @theme tokens:
 *   --color-sage       → MAP_SAGE
 *   --color-sage-light → MAP_SAGE_HIGHLIGHTED
 */

/** Primary trail / selection color (#5f8367 = --color-sage) */
export const MAP_SAGE = '#5f8367'

/** Hover / highlighted trail color — slightly darker sage */
export const MAP_SAGE_HIGHLIGHTED = '#3d6b47'

/** Lake fill and outline color */
export const MAP_LAKE = '#4a90b8'

/** Selected geocoder place pin (neutral gray — not a trail, not a lake) */
export const MAP_PLACE = '#6b7280'

/** Nearby-trail default color (muted gold) */
export const MAP_NEARBY_DEFAULT = '#D4A843'

/**
 * Loaded-elevation buffer extent color (cool indigo). Distinct from the sage
 * selection and the blue lake layers so the faint buffer rectangle reads as
 * "data extent" rather than a selection or a lake.
 *
 * @deprecated The buffer extent is now a HARD movement limit drawn in
 * {@link MAP_LIMIT}; this informational-overlay color is no longer used.
 */
export const MAP_BUFFER = '#6b7fd7'

/**
 * Movement-limit border color (warm coral). Marks the hard boundary the
 * selection bbox cannot be dragged or resized past (the +20% buffered extent of
 * the active terrain preview). Also colors the FROZEN locked-build selection box
 * (a non-editable red highlight) so it reads as "committed / locked in" while the
 * build panel is open. Deliberately a warm "stop" hue so it reads as a limit,
 * with clear contrast against the sage selection (#5f8367), the indigo
 * data-extent color (#6b7fd7), and the blue lakes (#4a90b8).
 */
export const MAP_LIMIT = '#e2554f'

/** Park boundary line color — dark sage */
export const MAP_PARK_BOUNDARY_LINE = '#3d5a42'

/**
 * Puzzle cut-line ink for the live cut-grid preview (`ws-cut-grid-line`), drawn
 * over a white casing. The ink of {@link MAP_SAGE_HIGHLIGHTED}'s family, dark
 * enough to read on topo and (with the casing) on satellite imagery.
 */
export const MAP_CUT = '#2f3a33'
